<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <h1 class="mb-0">{{ page_title }}</h1>
    <div class="page-title-actions d-flex flex-wrap gap-2">
      <a mat-stroked-button routerLink="categories">
        <mat-icon>category</mat-icon>
        Gestionar categorías
      </a>
      <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Nueva skill
      </button>
    </div>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="slug">
          <th mat-header-cell *matHeaderCellDef>Slug</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.slug }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource" class="actions-cell">
            <div class="table-actions">
              <button mat-icon-button type="button" matTooltip="Editar" (click)="openEditDialog(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button type="button" color="warn" matTooltip="Eliminar" (click)="deleteSkill(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
